module.exports = __webpack_public_path__ + "public/img/ico-pw-rule-ok.3446ee45.svg";